import {
  ArrowLeft,
  Globe,
  EyeOff,
  Monitor,
  Smartphone,
  Loader2,
  Check,
  Save,
  Zap,
  Send,
} from "lucide-react";
import { editorColors as colors, fonts } from "../../styles/theme";

export default function EditorTopBar({
  navigate,
  previewMode,
  setPreviewMode,
  saving,
  saved,
  handleSave,
  testSending,
  testSent,
  handleTestSend,
  setShowSendModal,
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 20px",
        background: colors.bgCard,
        borderBottom: `1px solid ${colors.border}`,
        flexShrink: 0,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <button
          onClick={() => navigate("/newsletters")}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            background: "transparent",
            border: "none",
            color: colors.textSecondary,
            cursor: "pointer",
            fontSize: 13,
            fontFamily: fonts.body,
            padding: "4px 8px",
            borderRadius: 4,
          }}
        >
          <ArrowLeft size={16} />
          <span>Back to Newsletters</span>
        </button>
        <div style={{ width: 1, height: 20, background: colors.border }} />
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Globe size={16} color={colors.accent} />
          <span
            style={{
              fontFamily: fonts.heading,
              fontSize: 14,
              fontWeight: 700,
              color: colors.text,
            }}
          >
            Newsletter Editor
          </span>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <div
          style={{
            display: "flex",
            background: colors.bg,
            borderRadius: 6,
            padding: 2,
            border: `1px solid ${colors.border}`,
          }}
        >
          {[
            { id: null, icon: EyeOff, label: "Edit" },
            { id: "desktop", icon: Monitor, label: "Desktop" },
            { id: "mobile", icon: Smartphone, label: "Mobile" },
          ].map((mode) => (
            <button
              key={mode.label}
              onClick={() => setPreviewMode(mode.id)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 5,
                padding: "5px 10px",
                borderRadius: 4,
                border: "none",
                fontSize: 12,
                fontWeight: 600,
                fontFamily: fonts.body,
                cursor: "pointer",
                transition: "all 0.12s",
                background:
                  previewMode === mode.id ? colors.accentDim : "transparent",
                color:
                  previewMode === mode.id ? colors.accent : colors.textSecondary,
              }}
            >
              <mode.icon size={14} />
              {mode.label}
            </button>
          ))}
        </div>

        <div style={{ width: 1, height: 20, background: colors.border }} />

        <button
          onClick={handleSave}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            padding: "7px 14px",
            borderRadius: 6,
            border: `1px solid ${colors.border}`,
            background: colors.bgCard,
            color: saved ? colors.success : colors.text,
            fontSize: 13,
            fontWeight: 600,
            fontFamily: fonts.body,
            cursor: "pointer",
          }}
        >
          {saving ? (
            <Loader2 size={14} className="spin" />
          ) : saved ? (
            <Check size={14} />
          ) : (
            <Save size={14} />
          )}
          {saving ? "Saving..." : saved ? "Saved!" : "Save Draft"}
        </button>

        <button
          onClick={handleTestSend}
          disabled={testSending || saving}
          title="Send a test email to yourself"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            padding: "7px 14px",
            borderRadius: 6,
            border: `1px solid ${testSent ? colors.success + "66" : colors.border}`,
            background: testSent ? colors.success + "15" : colors.bgCard,
            color: testSent ? colors.success : colors.text,
            fontSize: 13,
            fontWeight: 600,
            fontFamily: fonts.body,
            cursor: testSending || saving ? "not-allowed" : "pointer",
            opacity: testSending || saving ? 0.7 : 1,
          }}
        >
          {testSending ? (
            <Loader2 size={14} className="spin" />
          ) : testSent ? (
            <Check size={14} />
          ) : (
            <Zap size={14} />
          )}
          {testSending
            ? "Sending..."
            : testSent
              ? `Sent to ${testSent.sentTo}`
              : "Send Test"}
        </button>

        <button
          onClick={async () => {
            const result = await handleSave();
            if (result) setShowSendModal(true);
          }}
          disabled={saving}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            padding: "7px 14px",
            borderRadius: 6,
            border: "none",
            background: colors.accent,
            color: colors.bg,
            fontSize: 13,
            fontWeight: 700,
            fontFamily: fonts.body,
            cursor: saving ? "not-allowed" : "pointer",
            opacity: saving ? 0.7 : 1,
          }}
        >
          <Send size={14} />
          Send / Schedule
        </button>
      </div>
    </div>
  );
}
